import { memo } from 'react'
import { z } from 'zod'

import { EVENTS } from '@/constants/analytics'
import { useAnalytics } from '@/context/AnalyticsContext'
import type { PortableTextTypeComponentProps } from '@portabletext/react'

const streamable = z.object({
  _key: z.string().optional(),
  _type: z.literal('streamable'),
  url: z.string(),
  height: z.number().optional(),
  width: z.number().optional(),
  loop: z.boolean().optional(),
  autoplay: z.boolean().optional(),
})

const StreamableVideoRenderer = (props: {
  node: PortableTextTypeComponentProps<unknown>
  sectionName: string
}) => {
  const value = streamable.parse(props.node.value)
  const { track } = useAnalytics()

  return (
    <div
      className="relative flex flex-col overflow-hidden"
      style={{ height: value.height, maxWidth: value.width }}
    >
      <video
        muted
        playsInline
        disablePictureInPicture
        disableRemotePlayback
        autoPlay={value.autoplay}
        loop={value.loop}
        onPlay={() => {
          track(EVENTS.Streamable, {
            sectionName: props.sectionName,
          })
        }}
      >
        <source src={value.url} type="video/mp4" />
      </video>
    </div>
  )
}

export const StreamableVideo = memo(StreamableVideoRenderer)
